// Updated TS: manage-list-description.component.ts
import { Component, OnInit, Output, EventEmitter, Input, HostListener } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { BaseService } from "src/app/modules/base/base.service";
import { RepairOrderService } from "src/app/services/repair-order/repair-order.service";
import { ManageJobsComponent } from "../manage-jobs/manage-jobs.component";
import { ProductMatrixService } from "src/app/services/product-matrix/product-matrix.service";
import { AuthenticationService } from "src/app/services/authentication/authentication.service";
import { ConfirmationComponent } from "../confirmation/confirmation.component";
import { ContentTypeValues } from "src/app/common/constant/constant";
import { SuccessComponent } from "../success/success.component";

@Component({
  selector: "app-select-jobs-list",
  templateUrl: "./select-jobs-list.component.html",
  styleUrls: ["./select-jobs-list.component.scss"],
})
export class SelectJobsListComponent implements OnInit {
  @Input() title: string = "Title";
  @Input() height: number;
  @Input() apiData: any = {};
  @Input() type: any = 'title';
  @Input() selectType: any = 'single'; // 'single' or 'multiple'
  @Input() defaultSelected: any = [];

  @Output() selectedItems: EventEmitter<any> = new EventEmitter();

  listItems: any[] = [];
  selectedList: any[] = [];
  searchForm: FormGroup;
  searchVal: string = "";
  success: boolean = false;
  successMsg: string = "Data saved";
  allowAdd: boolean = true;
  canAdd: boolean = true;
  checkboxColor: string = "checkbox-hide";
  submitted: boolean = false;
  empty: boolean = false;
  searchTick: boolean = false;
  searchClose: boolean = false;
  actionFlag: boolean = false;

  public user: any;
  public domainId;
  public userId;
  public roleId;
  public callProFlag: boolean = false;

  itemLimit = 20;
  itemOffset = 0;
  itemTotal = 0;

  jobCode: string = ''
  jobTitle: string = ''
  jobDesc: string = ''
  jobPrice: string = ''
  jobDiscount: string = ''
  jobWd: string = ''

  error: boolean = false;
  errorMsg: string = "Failed to save";

  workstreamListsOptions = []
  companiesList = []
  selectedCompanyValue: any
  compListhoveredIndex: any = null;

  public loading = false;
  public isLoadingMore = false;
  public isClosable = true;
  private scrollContainer: HTMLElement;

  public accessLevel : any = {view: true, create: false, edit: false, delete:false};

  get f() {
    return this.searchForm.controls;
  }

  private handleEscape = (event: KeyboardEvent) => {
    if (event.key === 'Escape' && this.isClosable) {
      console.log('Escape key pressed');
      this.activeModal.dismiss("Cross click");
    }
  };


  constructor(
    private authenticationService: AuthenticationService,
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private modalService: NgbModal,
    private baseSerivce: BaseService,
    private repairOrderApi: RepairOrderService,
    private ProductMatrixApi: ProductMatrixService,
  ) {}

  ngOnInit(): void {
    this.searchForm = this.fb.group({
      searchKey: ["", Validators.required],
    });
    this.error=false;
    this.errorMsg='';
    this.selectedList = this.getFormattedData(this.defaultSelected) || [];
    this.listItems = this.getFormattedData(this.defaultSelected) || [];

    this.user = this.authenticationService.userValue;
    this.domainId = this.user.domain_id;
    this.userId = this.user.Userid;
    this.roleId = this.user.roleId;

    let callProFlag:any = localStorage.getItem('callProFlag');
    callProFlag = (callProFlag && callProFlag != undefined) ? callProFlag : 0;
    this.callProFlag = (callProFlag == 1) ? true : false;

    this.checkAccessLevel();

    this.getWorkstreamLists();
    this.getCompaniesListData();
    // this.loadItems(); // Moved inside getCompaniesListData

    setTimeout(() => {
      this.scrollContainer = document.getElementById('manageTable');
      if (this.scrollContainer) {
        this.scrollContainer.addEventListener('scroll', this.onScroll.bind(this));
      }
    }, 100);

    document.addEventListener('keydown', this.handleEscape);
  }
  ngOnDestroy(): void {
    document.removeEventListener('keydown', this.handleEscape);
    if (this.scrollContainer) {
      this.scrollContainer.removeEventListener('scroll', this.onScroll.bind(this));
    }
  }

  getFormattedData(data: any[]) {
    console.log("default selected: ", data);
    
    if(this.type != 'jobs-list') {
      return data || [];
    }
    
    const formattedData = data?.map((item) => {
      return {
        ...(item || {}),
        id: item?.jobId || item?.id,
        jobCode: item?.jobcode,
        jobtitle: item?.jobtitle,
        jobdesc: item?.jobdesc,
        unitPrice: item?.unitPrice || item?.jobPrice,
        discount: item?.discount || item?.jobDiscount,
        wdPrice: item?.wdPrice || item?.jobWdTotal,
        qbId: item?.qbId,
        jobDuration: item?.jobDuration,
        jobNotes: item?.jobNotes || '',
        jobMedia: item?.jobMedia || [],
        isApproved: item?.isApproved ?? 1,
        optionName: this.getOptionName(item),
        optionValue: this.getOptionValue(item),
        checkFlag: true,
        editAccess: 1,
        action: "",
        displayFlag: true,
      };
    });

    return formattedData || [];
  }

  sortCheckedToTop(items) {
    return items.sort((a, b) => {
      // If both items have the same checkFlag, maintain their relative order
      if (a?.checkFlag === b?.checkFlag) {
        return 0;
      }
      // Items with checkFlag: true come first
      return a?.checkFlag ? -1 : 1;
    });
  }

  getCompaniesListData() {
    const payload = new FormData();
    payload.append('domainId', this.apiData['domainId']);
    payload.append('userId', this.apiData['userId']);
    
    this.repairOrderApi.getCompaniesList(payload).subscribe(
      (res)=> {
        if (res?.status == 'Success') {
          this.companiesList = res?.data || [];
          if(this.companiesList && this.companiesList.length > 1) {
            let company = this.companiesList.find((res)=> {
              return res.name === 'General';
            });
            if (company) {
              this.selectedCompanyValue = company;
            }
          };
          const generalIndex = this.companiesList.findIndex(item => item.name === "General");
          if (generalIndex > 0) {
            const [generalItem] = this.companiesList.splice(generalIndex, 1);
            this.companiesList.unshift(generalItem);
          }
          this.companiesList.splice(0, 0, { id: 0, name: 'New', logo: null });
          // setTimeout(() => {
          //   this.checkAccessLevel();
          // }, 10);
        }

        this.loadItems()
      },
      (error) => {
        this.loadItems()
      }
    )
  }

  getWorkstreamLists() {
    let type:any = 1;
    const apiFormData = new FormData();
    apiFormData.append('apiKey', this.apiData['apiKey']);
    apiFormData.append('domainId', this.apiData['domainId']);
    apiFormData.append('countryId', this.apiData['countryId']);
    apiFormData.append('userId', this.apiData['userId']);
    apiFormData.append('type', type);
    this.workstreamListsOptions = [];
    this.ProductMatrixApi.getWorkstreamLists(apiFormData).subscribe((response) => {
      let resultData = response.workstreamList;
      this.workstreamListsOptions = resultData;   
    });
  }

  getJobsData(push: boolean = false){
    this.error=false;
    this.errorMsg='';

    if(push){
      this.isLoadingMore = true;
    } else {
      this.loading = true;
    }

    const data = new FormData();
    data.append("apiKey", this.apiData?.apiKey);
    data.append("domainId", this.apiData?.domainId);
    data.append("countryId", this.apiData?.countryId);
    data.append("userId", this.apiData?.userId);
    data.append("type", this.apiData?.type);
    data.append("offset", String(this.itemOffset));
    data.append("limit", String(this.itemLimit));
    data.append('search', this.searchVal);

    if(this.selectedCompanyValue?.id){
      data.append('jcId', this.selectedCompanyValue?.id)
    }

    this.repairOrderApi.getJOBDetailsList(data).subscribe(
      (response) => {     
        console.log("getJOBDetailsList: ", response);
        let responseData = response.data
        let resItems = responseData?.items || []
        this.itemTotal = Number(responseData?.total || 0)

        if (Array.isArray(resItems)) {
          const idsToCheck = this.selectedList?.map(a => a?.jobId) || []
          const formattedData = response?.items?.map((item) => {
            return {
              ...(item || {}),
              id: item?.id,
              jobCode: item?.jobCode,
              jobtitle: item?.jobtitle,
              jobdesc: item?.jobdesc,
              unitPrice: item?.unitPrice,
              discount: item?.discount,
              wdPrice: item?.wdPrice,
              qbId: item?.qbId,
              jobDuration: item?.jobDuration,
              optionName: this.getOptionName(item),
              optionValue: this.getOptionValue(item),
              checkFlag: idsToCheck?.includes(item?.id) || false,
              jobNotes: '',
              jobMedia: [],
              isApproved: 1,
              editAccess: 1,
              action: "",
              displayFlag: true,
            };
          })?.filter(item => !this.listItems?.some(a => a?.id == item?.id));

          if(push) {
            this.listItems = this.sortCheckedToTop([...this.listItems, ...formattedData]);
          } else {
            if(this.selectedList?.length){
              this.listItems = this.sortCheckedToTop([...this.selectedList, ...formattedData]);
            } else {
              this.listItems = this.sortCheckedToTop(formattedData || []);
            }
          }
          this.empty = this.listItems.length === 0;

          // Update pagination
          this.itemOffset += this.itemLimit;
        }
        this.loading = false;
        this.isLoadingMore = false;
        console.log("this.listItems: ", this.listItems);
        
      }, 
      (error) => {
        console.log("getJOBDetailsList Error: ", error);
        this.listItems = [];
        this.empty = this.listItems.length === 0;
        this.loading = false;
        this.isLoadingMore = false;
      }
    )
  }

  getOptionName(data:any) {
    return ""
  }

  getOptionValue(data:any) {
    let parsed = []
    if(data?.optionValues) {
      console.log("getOptionValue: ", data?.optionValues, typeof data?.optionValues);
      parsed = JSON.parse(data?.optionValues)
    }
    let dataArr = []
    if(Array.isArray(parsed)) {
      dataArr = parsed?.map(val => val.name)
    }
    if(dataArr?.includes("Any")){
      return ''
    }
    return dataArr?.join(', ') || ""
  }
  onScroll(event: any): void {  
    if (this.itemTotal <= this.listItems?.length  || this.isLoadingMore) {
      return;
    }

    const element = event.target;
    const atBottom = element.scrollHeight - element.scrollTop <= element.clientHeight + 50;

    console.log("onScroll: ", {atBottom});
    if (atBottom) {
      this.loadItems(true);
    }
  }
  

  loadItems(push: boolean = false) {
   switch (this.type) {
    case 'jobs-list':
      this.getJobsData(push)
      break;
   
    default:
      break;
   }
  }

  toggleItemSelection(item: any) {
    if (this.selectType === 'single') {
      // Toggle the clicked item's check state
      item.checkFlag = !item.checkFlag;
    
      if (item.checkFlag) {
        // Uncheck all other items in the list
        this.listItems.forEach(listItem => {
          if (listItem.id !== item.id) {
            listItem.checkFlag = false;
          }
        });
        // Set the selected list to only the current item
        this.selectedList = [item];
      } else {
        // If unchecking, remove the item from the selection
        this.selectedList = this.selectedList.filter(sel => sel.id !== item.id);
      }
    }
    if(this.selectType === 'multiple') {
      item.checkFlag = !item.checkFlag;
      if (item.checkFlag) {
        this.selectedList.push(item);
      } else {
        this.selectedList = this.selectedList.filter((sel) => sel.id !== item.id);
      }
    }
    this.updateHeaderCheckState();
    this.listItems = this.sortCheckedToTop(this.listItems || []);
    console.log("toggleItemSelection this.selectedList: ", this.selectedList);
    console.log("toggleItemSelection this.listItems: ", this.listItems);
  }

  toggleAll() {
    const isAllSelected = this.selectedList.length === this.listItems.length;
    this.selectedList = [];
    this.listItems.forEach((item) => {
      item.checkFlag = !isAllSelected;
      if (!isAllSelected) this.selectedList.push(item);
    });
    this.updateHeaderCheckState();
  }

  updateHeaderCheckState() {
    if (this.selectedList.length === this.listItems.length) {
      this.checkboxColor = "checkbox-show active";
    } else if (this.selectedList.length > 0) {
      this.checkboxColor = "checkbox-show checked";
    } else {
      this.checkboxColor = "checkbox-hide";
    }
  }

  clearSelection() {
    this.selectedList = [];
    this.listItems.forEach((item) => (item.checkFlag = false));
    this.updateHeaderCheckState();
  }

  applySelection() {
    if (this.selectedList.length) {
      this.selectedItems.emit(this.selectedList);
      this.success = true;
      this.activeModal.dismiss("Cross click");
      setTimeout(() => (this.success = false), 2000);
    }
  }

  filterCompany(event: any) {
    console.log("filter company", event);

    this.itemOffset = 0;
    this.loadItems();
  }

  onSearchChange(value: string) {
    this.searchVal = value;
    this.searchTick = value.length > 0;
    this.searchClose = this.searchTick;
    
    if (!value) {
      this.itemOffset = 0;
      this.loadItems();
      return;
    }

    // const filtered = this.listItems.filter((item) =>
    //   item.name.toLowerCase().includes(value.toLowerCase())
    // );
    // this.empty = filtered.length === 0;
    // this.listItems.forEach(
    //   (item) => (item.displayFlag = filtered.includes(item))
    // );
  }

  applySearch() {
    this.itemOffset = 0;
    this.loadItems();
  }

  clearSearch() {
    this.searchVal = "";
    this.searchForm.reset();
    this.searchTick = false;
    this.searchClose = false;
    this.itemOffset = 0;
    this.loadItems();
  }

  onChangeHandle(){
    console.log("onChangeHandle");
    this.error=false;
    this.errorMsg='';
  }

  // startAddNew() {
  //   // Keep the current search value instead of clearing it
  //   // const currentSearchValue = this.searchForm.get('searchKey').value || item?.name || '';
  //   // this.searchVal = currentSearchValue;

  //   this.actionFlag = true;
    
  //   const newItem = {
  //     id: Date.now(),
  //     // id: item?.id || Date.now(),
  //     name: '', // Set the name to current search value
  //     checkFlag: false,
  //     editAccess: 1,
  //     action: "new",
  //     displayFlag: true,
  //     // isEdit: !!item,
  //   };
  //   this.listItems.unshift(newItem);
  //   this.empty = this.listItems.length === 0;
  // }
  startAddNew() {
    console.log("startAddNew"); 
    this.isClosable = false;
     const modalRef = this.modalService.open(ManageJobsComponent, {
          backdrop: "static",
          keyboard: false,
          centered: true,
          size: "xl",
          windowClass: 'jobs-popup-custom-model'
      });
      const iHeight = window.innerHeight
      modalRef.componentInstance.access = "job-rate";
      modalRef.componentInstance.workstreamListsOptions = this.workstreamListsOptions || [];
      modalRef.componentInstance.productsList = this.listItems || [];
      modalRef.componentInstance.jcId = this.selectedCompanyValue?.id || '';
      modalRef.componentInstance.accessLevel = this.accessLevel;
      modalRef.componentInstance.showDialog = true; 

      console.log("accessLevel: ", this.accessLevel);
      

      modalRef.componentInstance.jobCallback.subscribe((receivedService) => {
        console.log("jobCallback: ", receivedService);
        this.isClosable = true;
        modalRef.dismiss("Close");
        if(receivedService?.action == 'new'){
          this.itemOffset = 0;
          this.getJobsData();
        }
      })
      
  }

  confirmAddNew() {
      switch (this.type) {
        case 'jobs-list':
          this.createJobs();
          break;
  
        default:
          break;
      }
  }
  
  createJobs() {

    console.log("createJobs: ", {
        jobCode: this.jobCode,
        jobTitle: this.jobTitle,
        jobDesc: this.jobDesc,
        jobPrice: this.jobPrice,
        jobDiscount: this.jobDiscount,
        jobWd: this.jobWd
    });
    
    const data = new FormData();
    data.append("apiKey", this.apiData?.apiKey);
    data.append("name", this.searchVal);
    data.append("domainId", this.apiData?.domainId);
    // data.append("id", "");

    // this.ProductMatrixApi.manageMsoNameLists(data).subscribe(
    //   (response: any) => {
    //     console.log("manageMsoNameLists response: ", response);

    //     this.actionFlag = false;
    //     this.searchVal = "";
    //     this.searchForm.reset();
    //     this.loading = false;
    //     this.defaultSelected = response?.data?.id ? [response?.data] : [];
    //     this.selectedList = this.defaultSelected;
    //     this.loadItems();
    //   },
    //   (error: any) => {
    //     console.log("manageMsoNameLists error: ", error);
    //     this.loading = false;
    //     this.loadItems();
    //   }
    // );

  }

  cancelAddNew() {
    if (this.listItems[0].action === "new") {
      this.listItems.shift();
      this.empty = this.listItems.length === 0;
    }
    this.actionFlag = false;
    this.jobCode = ''
    this.jobTitle = ''
    this.jobDesc = ''
    this.jobPrice = ''
    this.jobDiscount = ''
    this.jobWd = ''
    // this.searchForm.reset();
  }

  editJob(jobItem) {
    console.log("editJob");

     const modalRef = this.modalService.open(ManageJobsComponent, {
          backdrop: "static",
          keyboard: false,
          centered: true,
          size: "xl",
          windowClass: 'jobs-popup-custom-model'
      });
      const iHeight = window.innerHeight
      modalRef.componentInstance.access = "job-rate";
      modalRef.componentInstance.workstreamListsOptions = this.workstreamListsOptions || [];
      modalRef.componentInstance.productsList = this.listItems || [];
      modalRef.componentInstance.currentData = jobItem;
      modalRef.componentInstance.jcId = this.selectedCompanyValue?.id || '';
      modalRef.componentInstance.accessLevel = this.accessLevel;
      modalRef.componentInstance.showDialog = true; 

      console.log("accessLevel: ", this.accessLevel);
    
      modalRef.componentInstance.jobCallback.subscribe((receivedService) => {
        console.log("jobCallback: ", receivedService);
        modalRef.dismiss("Close");
        if(receivedService?.action == 'new'){
          this.itemOffset = 0;
          console.log("data: ", receivedService);
          console.log("data listItems: ", this.listItems);
          console.log("data selectedItems: ", this.selectedItems);
          const updatedJob = receivedService?.response?.[0] || {}

          this.listItems = this.listItems.map(item => {
            if(item.id === updatedJob.id) {
              return {
                ...item,
                ...updatedJob,
                id: updatedJob?.id,
                jobCode: updatedJob?.jobCode,
                jobtitle: updatedJob?.jobtitle,
                jobdesc: updatedJob?.jobdescription,
                unitPrice: updatedJob?.unitPrice,
                discount: updatedJob?.discount,
                wdPrice: updatedJob?.wdPrice,
                qbId: updatedJob?.qbId,
                jobDuration: updatedJob?.jobDuration,
                optionName: this.getOptionName(updatedJob),
                optionValue: this.getOptionValue(updatedJob),
                checkFlag: item?.checkFlag || false,
                editAccess: 1,
                action: "",
                displayFlag: true,
              }
            }
            return item;
          })

          this.selectedList = this.selectedList.map(item => {
            if(item.id === updatedJob.id) {
              return {
                ...item,
                ...updatedJob,
                id: updatedJob?.id,
                jobCode: updatedJob?.jobCode,
                jobtitle: updatedJob?.jobtitle,
                jobdesc: updatedJob?.jobdescription,
                unitPrice: updatedJob?.unitPrice,
                discount: updatedJob?.discount,
                wdPrice: updatedJob?.wdPrice,
                qbId: updatedJob?.qbId,
                jobDuration: updatedJob?.jobDuration,
                optionName: this.getOptionName(updatedJob),
                optionValue: this.getOptionValue(updatedJob),
                checkFlag: item?.checkFlag || false,
                editAccess: 1,
                action: "",
                displayFlag: true,
              }
            }
            return item;
          })
          this.listItems = this.sortCheckedToTop(this.listItems || []);
          // this.getJobsData(); // api call
        }
      })
  }

  deleteJob(jobItem) {
    console.log("deleteJob");

    const modalRef = this.modalService.open(ConfirmationComponent, { 
      backdrop: 'static', keyboard: false, centered: true 
    });
    modalRef.componentInstance.access = 'Delete';
    modalRef.componentInstance.confirmAction.subscribe((receivedService) => {
      modalRef.dismiss('Cross click');
      if(receivedService) {
        console.log("Delete confirmed for job: ", jobItem);
        let data = new FormData();
        data.append("apiKey", this.apiData?.apiKey);
        data.append("domainId", this.apiData?.domainId);
        data.append("userId", this.apiData?.userId);
        data.append('contentTypeId', ContentTypeValues.RepairOrder);
        data.append('action', 'delete');
        data.append('id', jobItem?.id);

        this.repairOrderApi.updateJOBDetailsList(data).subscribe(
          (response) => {
            console.log("updateJOBDetailsList response: ", response);
            
            if(response.status=='Success') {
              const modalMsgRef = this.modalService.open(SuccessComponent, { backdrop: 'static', keyboard: false, centered: true });
              modalMsgRef.componentInstance.msg = response.message;
              setTimeout(() => {
                this.itemOffset = 0;
                this.getJobsData();
                modalMsgRef.dismiss('Cross click');
              }, 2000);
            }
          },
          (error) => {
            console.log("updateJOBDetailsList error: ", error);
          }
        );
      }
    });
  }

  close() {
    // this.selectedItems.emit(this.selectedList);
    this.activeModal.dismiss("Cross click");
  }

  checkAccessLevel(){
    console.log("checkAccessLevel");
    
    let viewAccess = true, createAccess = false, editAccess = true,  deleteAccess = true;

    setTimeout(() => {
      let accessLevels = this.authenticationService.checkAccessItems;
      if(accessLevels && accessLevels.length > 0) {
        let reportAccess = accessLevels[0].pageAccess;
        reportAccess.forEach(item => {
          let accessId = parseInt(item.id);
          let roles = item.roles;
          let roleIndex = roles.findIndex(option => option.id == this.roleId);
          if(roleIndex < 0) {
            return false;
          }
          let roleAccess = (roles[roleIndex].access && roles[roleIndex].access != undefined) ? roles[roleIndex].access : 0;
          console.log(accessId, roleAccess)
          switch (accessId) {
            case 1:
              // viewAccess = (roleAccess == 1) ? true : false;
              break;
            case 8:
              createAccess = (roleAccess == 1) ? true : false;
              break;
            case 3:
              // editAccess = (roleAccess == 1) ? true : false;
              break;
            case 4:
              // deleteAccess = (roleAccess == 1) ? true : false;
              break;
          }
        });

      }        
      let defaultAccessLevel : any = {view: viewAccess, create: createAccess, edit: editAccess, delete:deleteAccess};   
      this.accessLevel = defaultAccessLevel.create != undefined ?  defaultAccessLevel : this.accessLevel;      
    }, 1000)
  }
}
